import axios from "axios";
import { ApiUrl } from "../../api";
import { StorageService } from "../../../src/api/storage";

export const getAllProfileLookupApi = () => {
  return axios.get(ApiUrl.Visit.AllProfileLookup).then(({ data }) => {
    return data;
  });
};
